import { FilterFnOption } from "@tanstack/react-table";
import { TIsolation } from "../../../lib/types";
import { TIsolationFilters } from "../../organisms/IsolationFilter/IsolationFiltersModal";
import { getIsolationOptions, getLabelForIsolationStatus } from "../../organisms/JobFiltersModal/JobFiltersModal.util";
import { ISOLATION_DRAWING_STATUS_ENUM } from "../../../lib/constants/dbConstants";

export const isolationsGlobalFilterFn: FilterFnOption<TIsolation> = (
  row,
  _columnId,
  { filters, searchString }: { filters: TIsolationFilters; searchString: string }
) => {
  const { original } = row;

  if (
    // Search string doesn't match, skip the rows
    searchString &&
    !JSON.stringify(original).toLowerCase().includes(searchString.toLowerCase())
  ) {
    return false;
  }

  //filtering isolationStatus
  if (filters['ecowIsolation.statusComment']) {
    const isolationStatusValue = original.ecowIsolation?.statusComment || '';
    const labeledIsolationStatus = getLabelForIsolationStatus(isolationStatusValue);
    const statusValue = getIsolationOptions().includes(labeledIsolationStatus)
      ? labeledIsolationStatus
      : 'Other';
    if (
      // Permit status doesn't match, skip the rows
      filters['ecowIsolation.statusComment'].length > 0 &&
      !(statusValue && filters['ecowIsolation.statusComment'].includes(statusValue))
    )
      return false;
  }
  //filtering event
  if (filters.event) {
    const eventValue = original.tarJobs?.[0]?.tarEvent?.eventDescription || ''; //isolations 1:M jobs in same event
    if (
      // event doesn't match, skip the rows
      filters.event.length > 0 &&
      !(eventValue && filters.event.includes(eventValue))
    )
      return false;
  }
  //filtering required trades
  if (filters.requiredTrades && filters.requiredTrades.length > 0) {
    const rowTrades = (original.requiredTrades || '')
      .split(',')
      .map((s) => s.trim().toLowerCase());
  
    const filterTrades = filters.requiredTrades[0]
      .split(',')
      .map((s) => s.trim().toLowerCase());
  
    const hasMatchingTrade = filterTrades.some((filter) =>
      rowTrades.includes(filter)
    );
  
    if (!hasMatchingTrade) return false;
  }
  //filtering drawing status
  if (filters.drawingStatus) {
    const drawingStatusValue = ISOLATION_DRAWING_STATUS_ENUM[original.drawingStatus] || '';
    if (
      // drawing status doesn't match, skip the rows
      filters.drawingStatus.length > 0 &&
      !(drawingStatusValue && filters.drawingStatus.includes(drawingStatusValue))
    )
      return false;
  }
  //filtering field walk
  if (filters.fieldWalked) {
    const fieldWalkedValue = original.fieldWalked === true 
    ? 'YES'
    : original.fieldWalked === false
    ? 'NO'
    : '';
    if (
      // field walk doesn't match, skip the rows
      filters.fieldWalked.length > 0 &&
      !(fieldWalkedValue && filters.fieldWalked.includes(fieldWalkedValue))
    )
      return false;
  }

  //filtering isolation number and LOSH
  if (filters['isolationNumber']) {
    const isolationNumber = original?.isolationNumber;
    if (
      // isolation numbers don't match, skip the rows
      filters['isolationNumber'].length > 0 &&
      !(
        isolationNumber &&
        filters.isolationNumber.some((number) => isolationNumber.toLowerCase().includes(number.toLowerCase()))
      )
    )
      return false;
  }
  if (filters['loshNumber']) {
    const loshNumber = original?.loshNumber;
    if (
      // losh numbers don't match, skip the rows
      filters['loshNumber'].length > 0 &&
      !(loshNumber && filters.loshNumber.some((losh) => loshNumber===losh))
    )
      return false;
  }

  return true;
};